import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class TestimoniesSlider {
    constructor(el) {
        this.el = el;

        this.options = {
            autoPlay: false,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            fade: true,
            cellSelector: '.testimony',
            imagesLoaded: true,
            arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
            }
        };

        if (this.el) {
            this._init();
        }
    }

    _init() {
        this.slides = this.el.querySelectorAll('.testimony');
        this.slidesCount = this.slides.length;

        if (this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Flickity(this.el, this.options);
    }
}

export default TestimoniesSlider;
